export class Patient {

  constructor(id, externalId, name, lastName, email, allergens = [], disliked = []) {
    this._id = id;
    this._externalId = externalId;
    this._name = name;
    this._lastName = lastName;
    this._email = email;
    this._allergens = allergens;
    this._dislikedProducts = disliked;
  }

  get id() {
    return this._id;
  }

  get externalId() {
    return this._externalId;
  }

  get name() {
    return this._name;
  }

  get lastName() {
    return this._lastName;
  }

  fullName() {
    return this.name + ' ' + this.lastName;
  }

  get email() {
    return this._email;
  }

  get allergens() {
    return this._allergens;
  }

  get disliked() {
    return this._dislikedProducts;
  }

  hasAllergyForProduct(externalId) {
    return this._allergens.indexOf(externalId) !== -1;
  }

  dislikesProduct(externalId) {
    return this._dislikedProducts.indexOf(externalId) !== -1;
  }

  toJSON() {
    return {
      id: this.id,
      externalId: this.externalId,
      name: this.name,
      lastName: this.lastName,
      email: this.email,
      allergens: this.allergens,
      dislikedProducts: this.disliked,
    };
  }
}
